module.exports = __webpack_public_path__ + "static/media/icon-info.efe67167.svg";